"use client";

import { Disclosure } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'
import SizeBar from "@/components/help/sidebar";
import ScrollButton from '@/components/shared/scroll-top-button';

export default function Content({faqs, title = "Frequently asked questions"}) {
  return (
    <div className="min-h-full">
      <div className="py-32">
        <div className="mx-auto max-w-3xl sm:px-6 grid lg:max-w-5xl grid-cols-12 gap-8 px-2 lg:px-8">
          <div className="sm:col-span-3 block sm:border-r col-span-12">
            <SizeBar />
          </div>
          <div className="sm:col-span-9 col-span-12">
            <h1 className="text-2xl font-bold tracking-tight text-gray-900">{title}</h1>
            <dl className="mt-5 space-y-6 divide-y divide-gray-900/10">
              {faqs.map((faq) => (
                <Disclosure as="div" key={faq.question} className="pt-6">
                  {({ open }) => (
                    <> 
                      <dt>
                        <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                          <span className="text-base font-semibold leading-7">{faq.question}</span>
                          <span className="ml-6 flex h-7 items-center">
                            {open ? (
                              <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                            ) : (
                              <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                            )}
                          </span>
                        </Disclosure.Button>
                      </dt>
                      <Disclosure.Panel as="dd" className="mt-2 pr-12">
                        <p className="text-base leading-7 text-gray-600">{faq.answer}</p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              ))}
            </dl>
          </div>
        </div>
      </div>
      <ScrollButton />
    </div>
  )
}
